export default __webpack_public_path__ + "static/media/fail.e6e566b2.jpg";